/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Table,
} from 'reactstrap';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { NewOrderTableProps } from '../../../../shared/prop-types/TablesProps';

import Panel from '../../../../shared/components/Panel';

const DropDownMore = ({ index, handleDeleteRow }) => (
  <UncontrolledDropdown className="dashboard__table-more">
    <DropdownToggle>
      <p><DotsHorizontalIcon /></p>
    </DropdownToggle>
    <DropdownMenu className="dropdown__menu">
      <Link to={`/dashboard_e_commerce/edit/${index}`}><DropdownItem>Edit</DropdownItem></Link>
      <DropdownItem onClick={handleDeleteRow}>Delete</DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

DropDownMore.propTypes = {
  index: PropTypes.number.isRequired,
  handleDeleteRow: PropTypes.func.isRequired,
};

const NewOrderAmount = ({ quantity }) => {
  const amountClass = classNames({
    'dashboard__table-orders-amount': true,
    'dashboard__table-orders-amount--medium': quantity <= 100,
    'dashboard__table-orders-amount--low': quantity <= 20,
  });
  if (quantity > 150) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <span>{quantity}</span>
      </div>
    );
  } if (quantity > 100) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <div />
        <div />
        <span>{quantity}</span>
      </div>
    );
  } if (quantity > 50) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <div />
        <span>{quantity}</span>
      </div>
    );
  } if (quantity > 20) {
    return (
      <div className={amountClass}>
        <div />
        <div />
        <span>{quantity}</span>
      </div>
    );
  }
  return (
    <div className={amountClass}>
      <div />
      <span>{quantity}</span>
    </div>
  );
};

NewOrderAmount.propTypes = {
  quantity: PropTypes.number,
};

NewOrderAmount.defaultProps = {
  quantity: 0,
};

const NewOrders = ({ newOrder, onDeleteRow, title }) => (
  <Panel
    lg={12}
    md={12}
    title={title}
    subhead="Top 5 recent product launch stats"
  >
    <Table responsive striped className="dashboard__table-orders">
      <thead>
        <tr>
          <th>Product</th>
          <th>Days</th>
          <th>Rank</th>
          <th>Spend</th>
          <th>PPC Sales</th>
          <th>Total Sales</th>
          <th>TACoS</th>
          <th>CR</th>
          <th>ROAS</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {newOrder.map((order, index) => (
          <tr key={index}>
            <td className="dashboard__table-orders-title">
              <div className="dashboard__table-orders-img-wrap">
                <div className="dashboard__table-orders-img" style={{ backgroundImage: `url(${order.img})` }} />
              </div>
              {order.product}
            </td>
            <td>{order.days}</td>
            <td>
              <NewOrderAmount quantity={order.rank} />
            </td>
            <td className="dashboard__table-orders-total">{order.spend}</td>
            <td className="dashboard__table-orders-total">{order.ppcSales}</td>
            <td className="dashboard__table-orders-total">{order.totalSales}</td>
            <td>{order.tacos}</td>
            <td>{order.conversionRate}</td>
            <td>{order.roas}</td>
            <td>
              <DropDownMore index={index} handleDeleteRow={e => onDeleteRow(index, e)} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Panel>
);

NewOrders.propTypes = {
  newOrder: NewOrderTableProps.isRequired,
  onDeleteRow: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default NewOrders;
